import styled from 'styled-components';
import DispatchingUsers from './component';

export default styled(DispatchingUsers)`
  background: white;
  width: 300px;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  padding: ${(props) => props.theme.base.gridSizes.S};
  margin-top: 38px;
  position: relative;
`;
